const EVENTS = [
  ["BATCH", "Batch created", "User, source context, reporting metadata, worker configuration, and timestamps are associated with the processing run."],
  ["READ", "PDF processed", "The source PDF is processed with page-level extraction and progress information."],
  ["RESULT", "Outcome recorded", "SUCCESS, REVIEW, or FAILED is preserved at report level for history and operational review."],
  ["ERROR", "Error logged", "Recoverable database contention and genuine processing errors are distinguished for investigation."],
  ["WORD", "Report generated", "The consolidated Word report is generated after PDF processing and becomes downloadable only when ready."],
  ["ARCHIVE", "History retained", "Batch completion metadata and report history remain available through the application's audit/history workflow."],
];

const FLOW = ["Batch", "Process", "Validate", "Audit", "Word", "Archive"];

export default function AuditReporting() {
  return (
    <div className="space-y-4">
      <div>
        <p className="font-mono text-[10px] tracking-[0.25em] text-slate-500">AUDIT & REPORTING</p>
        <h4 className="mt-1 text-sm font-semibold text-white">Traceable processing from batch start to report</h4>
        <p className="mt-1 text-xs text-slate-400">Operational metadata, outcomes, timing, errors, and report state are retained so a completed batch can be understood after the processing session has ended.</p>
      </div>

      <div className="overflow-x-auto rounded-xl border border-white/10 bg-black/30 p-4">
        <div className="flex min-w-[560px] items-center justify-between gap-2">
          {FLOW.map((x, i) => (
            <div key={x} className="flex flex-1 items-center gap-2">
              <div className="flex min-w-0 flex-1 justify-center rounded-lg border border-purple-500/25 bg-purple-500/10 px-2 py-2">
                <span className="text-[10px] font-semibold text-slate-200">{x}</span>
              </div>
              {i < FLOW.length - 1 && <span className="text-slate-700">→</span>}
            </div>
          ))}
        </div>
      </div>

      <div className="space-y-1.5">
        {EVENTS.map(([id, label, desc], i) => (
          <div key={id} className="flex items-start gap-2 rounded-lg border border-white/10 bg-white/5 px-2.5 py-2">
            <span className="min-w-[62px] font-mono text-[9px] font-bold text-purple-300">{id}</span>
            <div className="min-w-0">
              <p className="text-[10px] font-medium text-slate-200">{label}</p>
              <p className="text-[10px] leading-relaxed text-slate-500">{desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="rounded-xl border border-emerald-500/20 bg-emerald-500/5 p-3">
        <p className="font-mono text-[10px] tracking-[0.2em] text-emerald-400">REPORT OUTPUT</p>
        <div className="mt-2 grid gap-2 sm:grid-cols-3">
          {[
            ["PDF results", "Per-report outcomes and processing statistics"],
            ["Word report", "Consolidated summary generated after completion"],
            ["Audit/history", "Batch metadata, timing and operational traceability"],
          ].map(([title, desc]) => (
            <div key={title} className="rounded-lg border border-emerald-500/10 bg-black/15 p-2.5">
              <p className="text-[10px] font-semibold text-slate-200">{title}</p>
              <p className="mt-0.5 text-[10px] leading-relaxed text-slate-500">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
